import API from "../api";
import { Event, QuotaItem } from "../../../types";
import { PayloadRepost, PayloadTransmissionAccess } from "@/types";
import { Commit } from "vuex";
export default {
  namespaced: true,
  state: {
    currentTransmission: {
      id: 0,
      title: "",
      startTime: "",
      duration: 0,
      notifyBeforeMinutes: 0,
      started: true,
      type: "",
      events: [
        {
          id: 0,
          name: "",
        },
      ],
      lounges: [
        {
          id: 0,
          name: "",
          color: "",
        },
      ],
      meetingId: 0,
      url: "",
      password: "",
      config: {
        expiredIn: "",
        token: "",
        sdkAppKey: "",
        expired: true,
      },
    },
    nextTransmissionList: [],
  },
  mutations: {
    setCurrentTransmission(state: any, payload: any) {
      state.currentTransmission = payload;
    },
    setNextTransmissionList(state: any, payload: any) {
      state.nextTransmissionList = payload;
    },
  },
  actions: {
    async requestNewPost(context: any, payload: any): Promise<any> {
      const { data } = await API.postNew(payload);
      return data;
    },
    async requestEvents(): Promise<Event[]> {
      const { data } = await API.getEvents();
      return data;
    },
    async requestCategories(): Promise<Event[]> {
      const { data } = await API.getCategories();
      return data;
    },
    async requestNewMarketingPost(context: any, payload: any): Promise<any> {
      const { data } = await API.postNewMartekingPost(payload);
      return data;
    },
    async requestQuota(): Promise<QuotaItem[]> {
      const { data } = await API.getQuota();
      return data;
    },
    async requestEditMarketingPost(context: any, payload: any): Promise<any> {
      const { data } = await API.putMartekingPost(payload);
      return data;
    },
    async requestUsersMark(context: any, payload: any): Promise<any> {
      const { data } = await API.getUsersMark(payload);
      return data;
    },
    async requestRepost(context: any, payload: PayloadRepost): Promise<any> {
      const { data } = await API.postRepost(payload);
      return data;
    },
    async requestEditRepost(
      context: any,
      payload: PayloadRepost
    ): Promise<any> {
      const { data } = await API.putRepost(payload);
      return data;
    },
    async requestActiveEvents(): Promise<Event[]> {
      const { data } = await API.getActiveEvents();
      return data;
    },
    async requestCurrentTransmission({
      commit,
    }: {
      commit: Commit;
    }): Promise<any> {
      const { data } = await API.getCurrentTransmission();
      commit("setCurrentTransmission", data);
      return data;
    },
    async requestNextTransmissionList({
      commit,
    }: {
      commit: Commit;
    }): Promise<any> {
      const { data } = await API.getNextTransmissionList();
      commit("setNextTransmissionList", data);
      return data;
    },
    updateNextTransmissionList(
      {
        commit,
      }: {
        commit: Commit;
      },
      payload: any
    ): void {
      commit("setNextTransmissionList", payload);
    },
    async requestCreateAccess(
      context: any,
      payload: PayloadTransmissionAccess
    ): Promise<any> {
      const { data } = await API.postCreateAccess(payload);
      return data;
    },
  },
  modules: {},
};
